module.exports = __webpack_public_path__ + "static/media/bands_dj.3ef941c6.svg";